/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Move",
  size: 20
}

const SvgMove = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path d="M4 5H1v4h1V6h2zM1 16h1v2h2v1H1zM14 16v3h-3v-1h2v-2z" />
    <path fill="none" d="M5.5 1.5h13v13h-13z" />
    <path d="M1 11h1v3H1zM6 18h3v1H6z" />
  </Svg>
)

SvgMove.defaultProps = defaultProps
export default SvgMove
